import { render, staticRenderFns } from "./GenreSelect.vue?vue&type=template&id=1e8724fe&"
import script from "./GenreSelect.vue?vue&type=script&lang=js&"
export * from "./GenreSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports